import { Injectable } from '@angular/core';
import { Infoblock } from '@main/infoblock/const';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, take, tap } from 'rxjs/operators';
import { InfoblockActions } from '../store/actions';
import { StateWithInfoblock } from '../store/infoblock-state';
import { MainSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class InfoblockFacade {
  constructor(protected store: Store<StateWithInfoblock>) {}

  loadInfoblockItems(cityId: string): void {
    this.store.dispatch(new InfoblockActions.LoadInfoblocks(cityId));
  }

  getInfoblockItems(cityId: string): Observable<Infoblock[]> {
    return this.store.select(MainSelectors.getInfoblockItemsValue(cityId)).pipe(
      tap((value) => {
        if (!value) {
          this.store
            .select(MainSelectors.getInfoblockItemsState(cityId))
            .pipe(
              take(1),
              filter((state) => !state.value && !state.loading && !state.error && !state.success),
            )
            .subscribe(() => {
              this.loadInfoblockItems(cityId);
            });
        }
      }),
      filter<Infoblock[]>(Boolean),
    );
  }

  closeInfoblocks(ids: string[]): void {
    this.store.dispatch(new InfoblockActions.CloseInfoblocks(ids));
  }

  getClosedInfoblockIds(): Observable<string[]> {
    return this.store.select(MainSelectors.getClosedInfoblockItems);
  }
}
